"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var insert_chart_1 = __importDefault(require("material-ui/svg-icons/editor/insert-chart"));
var recompose_1 = require("recompose");
var file_saver_1 = require("file-saver");
var lodash_1 = require("lodash");
var Input_1 = __importDefault(require("./Input"));
var Dialog_1 = __importDefault(require("./Dialog"));
var ButtonMenuRemote_1 = __importDefault(require("./ButtonMenuRemote"));
var Button_1 = __importDefault(require("./Button"));
var fetch_1 = __importDefault(require("../../utils/fetch"));
var content_disposition_1 = __importDefault(require("content-disposition"));
var fetchReport = function (reportId, input, urlPrefix) { return __awaiter(_this, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch_1.default(urlPrefix + "/api/reports/" + reportId + "/generate", {
                    method: 'POST',
                    headers: new Headers({ 'Content-Type': 'application/json' }),
                    body: JSON.stringify(input),
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
var labelFn = function (_a) {
    var label = _a.label;
    return label;
};
var extractFileName = function (response) {
    var headers = response.headers;
    var contentDisposition = headers.get('content-disposition');
    if (contentDisposition) {
        var disposition = content_disposition_1.default.parse(contentDisposition);
        return lodash_1.get(disposition, 'parameters.filename');
    }
    else {
        return null;
    }
};
var FileNameDialogBase = function (_a) {
    var dialogOpened = _a.dialogOpened, closeDialog = _a.closeDialog, submitDialog = _a.submitDialog, fileName = _a.fileName, onFileNameChange = _a.onFileNameChange, inputRef = _a.inputRef, submitDialogOnEnter = _a.submitDialogOnEnter;
    return (react_1.default.createElement(Dialog_1.default, { modal: false, open: dialogOpened, onRequestClose: closeDialog },
        react_1.default.createElement("div", null, "File name: "),
        react_1.default.createElement(Input_1.default, { name: "fileName", onKeyDown: submitDialogOnEnter, value: fileName, onChange: onFileNameChange, inputRef: inputRef }),
        react_1.default.createElement("br", null),
        react_1.default.createElement("br", null),
        react_1.default.createElement("div", { className: "buttons" },
            react_1.default.createElement(Button_1.default, { label: "Ok", onClick: submitDialog }),
            react_1.default.createElement(Button_1.default, { label: "Cancel", onClick: closeDialog }))));
};
var FileNameDialog = recompose_1.compose(recompose_1.defaultProps({
    dialogOpened: false,
    closeDialog: lodash_1.noop,
    submitDialog: lodash_1.noop,
    onDialogDataChange: lodash_1.noop,
}), recompose_1.withHandlers({
    submitDialogOnEnter: function (_a) {
        var submitDialog = _a.submitDialog;
        return function (event) {
            if (event.keyCode === 13) {
                submitDialog();
            }
        };
    },
    onFileNameChange: function (_a) {
        var onDialogDataChange = _a.onDialogDataChange;
        return function (value) {
            onDialogDataChange({ fileName: value });
        };
    },
}), recompose_1.withProps(function (_a) {
    var dialogData = _a.dialogData;
    return ({ fileName: lodash_1.get(dialogData, 'fileName') });
}))(FileNameDialogBase);
var ExportButton = function (_a) {
    var exportLabel = _a.exportLabel, location = _a.location, handleItemClick = _a.handleItemClick, urlPrefix = _a.urlPrefix, rest = __rest(_a, ["exportLabel", "location", "handleItemClick", "urlPrefix"]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(ButtonMenuRemote_1.default, { icon: react_1.default.createElement(insert_chart_1.default, null), label: exportLabel, url: urlPrefix + "/api/reports/public?location=" + location, onItemClick: handleItemClick, labelFunction: labelFn }),
        react_1.default.createElement(FileNameDialog, __assign({}, rest))));
};
exports.default = recompose_1.compose(recompose_1.defaultProps({
    input: {},
    useFileNameDialog: false,
    loaderFunction: lodash_1.noop,
    urlPrefix: '',
}), recompose_1.withHandlers(function () {
    var ref = null;
    return {
        dialogHandler: function (_a) {
            var urlPrefix = _a.urlPrefix, loaderFunction = _a.loaderFunction;
            return function (report, data) { return __awaiter(_this, void 0, void 0, function () {
                var id, response, blob, fileName;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            id = report.id;
                            loaderFunction(true);
                            return [4 /*yield*/, fetchReport(id, data, urlPrefix)];
                        case 1:
                            response = _a.sent();
                            return [4 /*yield*/, response.blob()];
                        case 2:
                            blob = _a.sent();
                            fileName = extractFileName(response);
                            loaderFunction(false);
                            file_saver_1.saveAs(blob, fileName ? fileName : report.fileName);
                            return [2 /*return*/];
                    }
                });
            }); };
        },
        inputRef: function (props) { return function (node) {
            ref = node;
        }; },
        getInputRef: function (props) { return function () { return ref; }; },
    };
}), recompose_1.withState('dialogData', 'setDialogData', null), recompose_1.withStateHandlers({
    dialogOpened: false,
    report: null,
    reportData: null,
}, {
    openDialog: function (state, props) { return function (report, reportData) {
        return { dialogOpened: true, report: report, reportData: reportData };
    }; },
    closeDialog: function () { return function () {
        return { dialogOpened: false };
    }; },
}), recompose_1.withHandlers({
    submitDialog: function (_a) {
        var closeDialog = _a.closeDialog, report = _a.report, reportData = _a.reportData, dialogData = _a.dialogData, dialogHandler = _a.dialogHandler;
        return function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dialogHandler(report, __assign({}, reportData, dialogData))];
                    case 1:
                        _a.sent();
                        closeDialog();
                        return [2 /*return*/];
                }
            });
        }); };
    },
    onDialogDataChange: function (_a) {
        var setDialogData = _a.setDialogData;
        return function (value) {
            setDialogData(value);
        };
    },
    handleItemClick: function (_a) {
        var input = _a.input, openDialog = _a.openDialog, useFileNameDialog = _a.useFileNameDialog, dialogHandler = _a.dialogHandler, getInputRef = _a.getInputRef;
        return function (report) { return __awaiter(_this, void 0, void 0, function () {
            var data, mayBePromise, _a, ref;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(input instanceof Function)) return [3 /*break*/, 4];
                        mayBePromise = input(report);
                        if (!(mayBePromise instanceof Promise)) return [3 /*break*/, 2];
                        return [4 /*yield*/, mayBePromise];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = mayBePromise;
                        _b.label = 3;
                    case 3:
                        data = _a;
                        return [3 /*break*/, 5];
                    case 4:
                        data = input;
                        _b.label = 5;
                    case 5:
                        if (!useFileNameDialog) return [3 /*break*/, 7];
                        return [4 /*yield*/, openDialog(report, data)];
                    case 6:
                        _b.sent();
                        ref = getInputRef();
                        if (ref && ref.focus instanceof Function) {
                            ref.focus();
                        }
                        return [3 /*break*/, 9];
                    case 7: return [4 /*yield*/, dialogHandler(report, data)];
                    case 8:
                        _b.sent();
                        _b.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        }); };
    },
}))(ExportButton);
//# sourceMappingURL=ExportButton.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/ExportButton.js
// module id = 948
// module chunks = 0